<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/users/users.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :exportCsv="exportCsv"
      :rowActionHandlers="rowActionHandlers"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Usurio', plural:'Usurios'}"
      :key="moduleName"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useUsersStore } from '@/store/users';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/users/users.config';
import { useDisplay } from 'vuetify';

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Users';
const preferencesStore = usePreferencesStore();
const usersStore = useUsersStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => usersStore.fetchUsers(params),
  {
    create: usersStore.createUser,
    update: (data) => usersStore.updateUser(data.id, data),
    remove: usersStore.deleteUser,
    //exportCsv: usersStore.exportCSV
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const rowActionHandlers = {
    
};

const data = computed(() => usersStore.users);
</script>
